export const YES = 'yes';
export const NO = 'no';
export const CUSTOM_LOGIC = 'custom_logic';
